<router-outlet></router-outlet>
    <div class="update" *ngIf="pendingUpdate" (click)="reloadPage()">
        <mat-icon>refresh</mat-icon> {{ 'common.newVersion' | translate }}
    </div>
<sba-session-indicator *ngIf="false"></sba-session-indicator>
